/** The pages anyone can open: home and pricing, sign-in pages, privacy and terms. */
import { useEffect } from "react";
import { isPublicPage, pageMeta } from "@brainlog/shared";
import { ForgotPage, LoginPage, ResetPage, SignupPage, VerifyPage } from "./AuthPages";
import { Landing } from "./Landing";
import { PrivacyPage, TermsPage } from "./Legal";
import { track } from "@/lib/analytics";

/** Pages that are public even for someone signed in. */
export const ALWAYS_PUBLIC = new Set(["/privacy", "/terms", "/verify-email", "/reset-password", "/pricing"]);
/** Pages that only make sense signed out (signed in, they lead into the app). */
export const SIGNED_OUT_ONLY = new Set(["/login", "/signup", "/forgot-password"]);

export function PublicSite({ path, signedIn }: { path: string; signedIn: boolean }) {
  useEffect(() => {
    if (path === "/pricing") requestAnimationFrame(() => document.getElementById("pricing")?.scrollIntoView());
    // The title search engines show (the server writes the rest of the head).
    document.title = pageMeta(isPublicPage(path) ? path : "/").title;
    track("page_view", undefined, path);
  }, [path]);
  switch (path) {
    case "/login":
      return <LoginPage />;
    case "/signup":
      return <SignupPage />;
    case "/forgot-password":
      return <ForgotPage />;
    case "/reset-password":
      return <ResetPage />;
    case "/verify-email":
      return <VerifyPage signedIn={signedIn} />;
    case "/privacy":
      return <PrivacyPage />;
    case "/terms":
      return <TermsPage />;
    default:
      return <Landing />;
  }
}
